import { ibkApi } from '@ibk/shared-config';
export const contractAddressesTag = (contractId) => ({
    type: 'Emissor',
    id: `addresses-${contractId}`,
});
const invalidateContractAddresses = (_result, _error, { contractId }) => [
    contractAddressesTag(contractId),
];
export const buildListAddressesQuery = ({ contractId }) => ({
    url: `/v1/benefits/contracts/${contractId}/addresses`,
    method: 'GET',
});
export const transformListAddressesResponse = (response) => response.result ?? [];
export const buildUpdateAddressMutation = ({ contractId, addressId, body }) => ({
    url: `/v1/benefits/contracts/${contractId}/addresses/${addressId}`,
    method: 'PATCH',
    body,
});
export const transformUpdateAddressResponse = (response) => response.result;
export const buildCreateAddressMutation = ({ contractId, body }) => ({
    url: `/v1/benefits/contracts/${contractId}/addresses`,
    method: 'POST',
    body,
});
export const buildDeleteAddressMutation = ({ contractId, addressId }) => ({
    url: `/v1/benefits/contracts/${contractId}/addresses/${addressId}`,
    method: 'DELETE',
});
export const buildActivateAddressMutation = ({ contractId, addressId }) => ({
    url: `/v1/benefits/contracts/${contractId}/addresses/${addressId}/activation`,
    method: 'POST',
});
export const contractAddressesApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        getEmissorContractAddresses: build.query({
            query: buildListAddressesQuery,
            transformResponse: transformListAddressesResponse,
            providesTags: (_result, _error, { contractId }) => [contractAddressesTag(contractId)],
        }),
        updateEmissorContractAddress: build.mutation({
            query: buildUpdateAddressMutation,
            transformResponse: transformUpdateAddressResponse,
            invalidatesTags: invalidateContractAddresses,
        }),
        createEmissorContractAddress: build.mutation({
            query: buildCreateAddressMutation,
            transformResponse: transformUpdateAddressResponse,
            invalidatesTags: invalidateContractAddresses,
        }),
        deleteEmissorContractAddress: build.mutation({
            query: buildDeleteAddressMutation,
            invalidatesTags: invalidateContractAddresses,
        }),
        activateEmissorContractAddress: build.mutation({
            query: buildActivateAddressMutation,
            invalidatesTags: invalidateContractAddresses,
        }),
    }),
    overrideExisting: false,
});
export const { useGetEmissorContractAddressesQuery, useUpdateEmissorContractAddressMutation, useCreateEmissorContractAddressMutation, useDeleteEmissorContractAddressMutation, useActivateEmissorContractAddressMutation, } = contractAddressesApi;
